__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['travel-lounge-finder-root'].baseUrl;
/* eslint import/no-unresolved: [2, { ignore: ['\\.css$'] }] -- for GitHub Action build/deploy */
import ModuleContainer from '@/components/TravelLoungeFinderRoot';
import './output_node_modules.css';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/one-xp-client-sdk': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.35.1',
      module: require('@americanexpress/one-xp-client-sdk')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.1.1',
      module: require('@americanexpress/reactlytics')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'travel-lounge-finder-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'travel-lounge-finder-root';
}